<script>
	import moment from 'moment'
	import ReservationStripeForm from './ReservationStripeForm'
	import PartecipantBirthdayInput from '../purchases/PartecipantBirthdayInput'
	import {Form} from '../../helpers/Form/Form'

	export default {
		props: {
			reservation: Number
		},
		components: {PartecipantBirthdayInput,ReservationStripeForm},
		data() {
			return {
				reservationData: null,
				provinces: [],
				municipalities: [],
				isLoading: false,
                formPay: new Form({
                	id: Math.random(),
                    email: null,
                    pay_method: null,
                    i_payment: null,
                    p_intent: null,
                    total: 0,
                    email: null,
                }),				
				form: new Form({
					id: this.reservation,
					card_owner: null,
					datetime: null,
					country: null,
					municipality: null,
					province: null,
					address: null,
					zip_code: null,
					first_name: null,
					last_name: null,
					house_number: null,
					phone: null,
					email: null,
					birthday: null,
					fiscal_code: null,
					price: 0,
					membership_fee: 0,
					course_id: null,
					paymentIntent: null,
					paymentMethod: null,
					p_intent: null,
					is_for_this_user: 0,
					time_range: null,
					is_for_user: false,
				}),
				interval: null
			}
		},
		computed: {
			responsibleMaxYear() {
				let now = moment()
				return now.year() - 18
			},
			canSubmit() {
				let addressEmpty = false
				if (this.form.country == 'Italia') {
					addressEmpty = !_.isEmpty(this.form.province) && !_.isEmpty(this.form.municipality)
				} else {
					addressEmpty = !_.isEmpty(this.form.municipality)
				}

				return !_.isEmpty(this.form.first_name) && !_.isEmpty(this.form.last_name)
					&& !_.isEmpty(this.form.email) && addressEmpty && !_.isEmpty(this.form.zip_code)
					&& !_.isEmpty(this.form.birthday) && !_.isEmpty(this.form.house_number)
			},
			mailable() {
				if (! _.isEmpty(this.reservationData)) {
					if (! this.form.is_for_user) {
						return !_.isEmpty(this.reservationData.responsible_email)
					}
				}
				return this.form.is_for_user
			},
            reservationTotal() {
                return this.form.price + this.form.membership_fee
            }			
		},
		watch: {
			'form.country': {
				handler(val) {
					if (val != 'Italia') {
						this.$set(this.form, 'municipality', null)
						this.$set(this.form, 'province', null)
					}
				}
			}
		},
		mounted() {
			this.getReservation()

			this.initCountrySelect2()
			this.initializeProvinceSelect2()
			this.initMunicipalitySelect2()
		},
		methods: {
			initCountrySelect2() {
				let vm = this;

                $(this.$refs.country).select2({
                    placeholder: 'Seleziona la nazione',
                    width: '100%',
                    ajax: {
                        url: route('countries.search'),
	                    data: function (params) {
	                        return {
	                        	q: params.term
	                        };
	                    },                        
                        processResults({countries}) {
                            let results = countries.map(i => {
                                return {
                                    id: i.name,
                                    text: i.name
                                }
                            })

                            return { results }
                        }
                    }
                }).on('change', function(e) {
                	vm.$set(vm.form, 'country', $(this).val())
                })
			},
			onClickBack() {
				let date = moment(this.form.datetime)
				let end = moment(this.form.datetime).add(this.interval, 'minutes')
				let timeRange = `${date.format('HH:mm')} - ${end.format('HH:mm')}`

				this.form
					.submit('delete', route('reservations.delete', this.form.id))
					.then(response => {
						let date = moment(this.form.datetime)
						let end = moment(this.form.datetime).add(this.interval, 'minutes')
						let timeRange = `${date.format('HH:mm')} - ${end.format('HH:mm')}`

						let source = route('reservations.reservation')
						location.href = `${source}?reservation_date=${date.format('YYYY-MM-DD')}&reservation_time=${timeRange}&course_id=${this.form.course_id}&price=${this.form.price}`
					})
			},
	        initializeProvinceSelect2(region = null) {
	            let vm = this;

	            $(this.$refs.province).select2({
	                placeholder: 'Seleziona la provincia',
	                ajax: {
	                    url: route('provinces.search'),
	                    data: function (params) {
	                        let data = {};
	                        data['q'] = params.term;
	                        if (typeof region !== 'undefined') {
	                            data['region'] = region;
	                        }
	                        return data;
	                    },
	                    processResults({provinces}) {
	                    	vm.$set(vm, 'provinces', provinces)
	                        var results = [];
	                        vm.provinces.forEach(function (a, b) {
	                            results.push({
	                                id: a.long_name,
	                                text: a.long_name
	                            })
	                        })
	                        // Transforms the top-level key of the response object from 'items' to 'results'
	                        return {
	                            results: results
	                        };
	                    }
	                }
	            }).on('change', function (event) {
	            	let opt = $(this).select2('data')[0]
                	if (!_.isEmpty(opt)) {
                		let province = _.head(vm.provinces.filter(i => i.long_name == opt['id']))
                		if (province) {
	                		vm.$set(vm.form, 'province', province.long_name)
		                    if (!_.isEmpty(vm.form.municipality)) {
			                    vm.initMunicipalitySelect2(province.id)
			                }
			            }
	                }
	            })
	        },    			
			initMunicipalitySelect2(province = null) {
				let vm = this;

                $(this.$refs.municipality).select2({
                    placeholder: 'Seleziona il comune',
                    width: '100%',
                    ajax: {
                        url: route('municipalities.search'),
	                    data: function (params) {
	                        let data = {};
	                        data['q'] = params.term;
	                        if (province) {
	                            data['province_id'] = province;
	                        }
	                        return data;
	                    },                        
                        processResults({municipalities}) {
                            let results = []
                            vm.$set(vm, 'municipalities', municipalities)

                            vm.municipalities.forEach(i => {
                                results.push({
                                    id: i.name,
                                    text: i.name
                                })
                            })

                            return {
                                results: results
                            }
                        }
                    }
                }).on('change', function(e) {
                	let opt = $(this).select2('data')[0]
                	if (!_.isEmpty(opt)) {
                		let municipality = _.head(vm.municipalities.filter(i => i.name == opt['id']))
                		if (municipality) {
	                		vm.$set(vm.form, 'municipality', municipality.name)
	                    	if (municipality.hasOwnProperty('province')) {
	                    		vm.initializeProvinceSelect2(municipality.region)
	                    	}
	                    }
	                }
                })
			},
			getReservation() {
				this.form
					.get(route('reservations.show', this.reservation))
					.then(({reservation}) => {
						this.updateReservation(reservation)
					})
			},
			updateReservation(reservation) {
				this.$set(this, 'reservationData', reservation)
				this.$set(this.form, 'id', reservation.id)
				this.$set(this.form, 'price', reservation.price)
				this.$set(this.form, 'membership_fee', reservation.membership_fee)
				this.$set(this.form, 'course_id', reservation.course_id)
				this.$set(this.form, 'datetime', reservation.datetime)
				this.$set(this.form, 'time_range', reservation.time_range)
				this.$set(this.form, 'is_for_user', reservation.is_for_user)
				this.$set(this, 'interval', reservation.course.days[0].interval)

				if (! _.isNull(reservation.responsible_first_name)) {
					this.$set(this.form, 'first_name', reservation.responsible_first_name)
					this.$set(this.form, 'last_name', reservation.responsible_last_name)
					this.$set(this.form, 'email', reservation.responsible_email)
					this.$set(this.form, 'phone', reservation.responsible_phone)
					this.$set(this.form, 'birthday', moment(reservation.responsible_birthday).format('YYYY-MM-DD'))
					this.$set(this.form, 'fiscal_code', reservation.responsible_fiscal_code)
				} else {
					if (this.form.is_for_user) {
						this.$set(this.form, 'first_name', reservation.first_name)
						this.$set(this.form, 'last_name', reservation.last_name)
						this.$set(this.form, 'email', reservation.email)
						this.$set(this.form, 'phone', reservation.phone)
						this.$set(this.form, 'birthday', moment(reservation.birthday).format('YYYY-MM-DD'))
						this.$set(this.form, 'fiscal_code', reservation.fiscal_code)		
					}					
				}				
			},
			onSubmit() {
				 $('#spinner-modal').modal('show');

				this.form
					.submit('post', route('reservations.validate'))
					.then(response => {
						this.processPayment()
					})
					.catch(error => $('#spinner-modal').modal('hide'))
			},
			processPayment() {
				this.$refs
					.paymentStripe
					.onSubmit()
					.then(({token, cardElements, stripe}) => {
						this.submitPayment(token)
					})
					.catch(error => $('#spinner-modal').modal('hide'))
			},
			submitPayment(token) {
                this.formPay.pay_method = token.id;
                this.formPay.total = this.form.price + this.form.membership_fee;
                this.formPay.email = this.form.email;

                this.formPay
                    .submit('post', route('payintent.create'))
                    .then( async ({intent}) => {
                        if (intent.status == 'succeeded') {
                            this.$set(this.form, 'paymentMethod', token.id)
                            this.$set(this.form, 'paymentIntent', intent.id)

                            this.form
                                .submit('post', route('reservations.postBuy', this.reservation))
                                .then(response => {
                                    $('#spinner-modal').modal('hide');
                                    this.isLoading = false;

                                    location.href = response.redirect
                                })
                        } else {
                            this.form.p_intent = intent.id
                            $('#spinner-modal').modal('hide');
                            const {paymentIntent, error} = await self.stripe.stripe.handleCardAction(
                                intent.client_secret
                            );
                            if (error) {
                            // The payment failed -- ask your customer for a new payment method.
                                this.isLoading = false;
                                window.alerts.error(error.message)
                            } else {
                                // The payment has succeeded.
                                $('#spinner-modal').modal();
                                this.$set(this.form, 'paymentIntent', paymentIntent.id)

                                this.form
                                    .submit('post', route('reservations.postBuy', this.reservation))
                                    .then(response => {
                                        $('#spinner-modal').modal('hide');
                                        this.isLoading = false;

                                        location.href = response.redirect
                                    })
                            }
                        }
                    })
                    .catch(error => {
                        $('#spinner-modal').modal('hide');
                        this.isLoading = false;
                        window.alerts.error('Qualcosa è andato storto durante la verifica del pagamento!');
                    })				
			}
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/reservation/ReservationPaymentForm.vue